module.exports = __webpack_public_path__ + "static/img/crayonrus.a8ab6fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/crayonrus.png
// module id = U9mu
// module chunks = 35